import { post } from '@api/api';
import API_ROUTES from '@api/routes';
import { useQuery } from '@tanstack/react-query';
import { auditTimePeriodToUnix } from '@utils/audits';
import { AuditsTimePeriod, IAudits } from 'types/audits';
import QueryKeys from '.';
import { useTenants } from './tenants';

const searchAudits = async (
	text: string,
	timePeriod: AuditsTimePeriod,
	excludedActions?: string[]
) => {
	const from = auditTimePeriodToUnix(timePeriod);
	const res = await post<
		{ text?: string; from: number; excludedActions?: string[] },
		IAudits
	>(API_ROUTES.v1.audits, {
		text,
		from,
		excludedActions
	});
	const audits = res.data;
	return audits;
};

export const useAudits = (
	text: string = '',
	timePeriod: AuditsTimePeriod = AuditsTimePeriod.Day,
	excludedActions?: string[]
) => {
	// Show loading until the tenants are loaded, this is done because the tenant data is used
	// In the audits table table
	const { isLoading } = useTenants();
	return useQuery(
		[QueryKeys.audits, text, timePeriod, excludedActions],
		() => searchAudits(text, timePeriod, excludedActions),
		{ enabled: !isLoading }
	);
};
